@for (field of fieldsArray.controls; track field; let i = $index) {
	<tec-item
		[title]="previewTypeLabel(i)"
		[disabled]="true"
		[clickeable]="false"
	></tec-item>
}
